<template>
  <div class="newsInformationDetails maxWidth">
    <div class="newsInformationDetails-mainTop">
      <span @click="backClick">资讯动态</span><span>></span
      ><span>{{ contentList.cname }}</span>
    </div>
    <div class="newsInformationDetails-main">
      <div class="newsInformationDetails-mainLeft">
        <div class="newsInformationDetails-mainLeftTop">
          <div class="title">
            <img src="../../assets/bigTy.png" alt="" />
            <span>{{ contentList.title }}</span>
          </div>
          <div class="mainLeftTop-data">
            <span class="data">{{ contentList.day }} /</span>
            <div class="yearBox">
              <span>{{ contentList.month }} </span>
              <span class="">{{ contentList.year }} </span>
            </div>
          </div>
          <div class="zuozhe">
            <span>作者：{{ contentList.author }}</span>
          </div>
        </div>
        <div
          class="newsInformationDetails-mainLeftText"
          v-html="contentList.content"
        ></div>
        <div class="newsInformationDetails-mainLeftBottom">
          <span class="title">相关阅读</span>
          <div class="">
            <span
              @click="lastClick(lastList.id)"
              v-if="lastList != '' && lastList != null && lastList.title != ''"
              >上一篇：{{
                lastList != "" && lastList != null ? lastList.title : ""
              }}</span
            >
            <span
              @click="nextClick(nextList.id)"
              v-if="nextList != '' && nextList != null && nextList.title != ''"
              >下一篇：{{
                nextList != "" && nextList != null ? nextList.title : ""
              }}</span
            >
          </div>
        </div>
      </div>
      <div class="newsInformationDetails-mainRight">
        <div class="newsInformationDetails-mainRightTop">
          <span>热门资讯</span>
        </div>
        <div class="newsInformationDetails-mainRightContent">
          <div
            class="mainRightContent-box"
            v-for="(item, index) in hotList"
            :key="index"
            @click="caseClick(item)"
          >
            <div class="mainRightContent-boxLeft">
              <img :src="item.bg" alt="" />
            </div>
            <div class="mainRightContent-boxRight">
              <span>{{ item.title }}</span>
              <p>{{ item.date }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsInformationDetails",
  data() {
    return {
      id: "",
      title: "",
      hotList: [],
      contentList: {},
      lastList: {},
      nextList: {}
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.$axios
        .get("index/common/getMessageContent", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.contentList = res.data.data.content;
            this.hotList = res.data.data.goods;
            this.lastList = res.data.data.last;
            this.nextList = res.data.data.next;
          }
        });
    },
    caseClick(item) {
      if (item.id != this.id) {
        this.id = item.id;
        this.getItemList();
        this.$router.push({
          name: "newsInformationDetails",
          query: { id: item.id }
        });
      }
      document.documentElement.scrollTop = 0;
    },
    backClick() {
      this.$router.push({
        name: "newsInformation"
      });
    },
    lastClick(id) {
      if (id != this.id) {
        this.$router.push({
          name: "newsInformationDetails",
          query: { id: id }
        });
        this.id = id;
        this.getItemList();
      }
      document.documentElement.scrollTop = 0;
    },
    nextClick(id) {
      if (id != this.id) {
        this.$router.push({
          name: "newsInformationDetails",
          query: { id: id }
        });
        this.id = id;
        this.getItemList();
      }
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.newsInformationDetails {
  width: 1920px;
  margin: 0 auto;
  margin-top: 70px;
}
.newsInformationDetails-main {
  margin-bottom: 60px;
}
.newsInformationDetails-mainTop {
  display: flex;
  width: 1280px;
  margin: 0 auto;
  align-items: center;
  padding: 44px 0 29px;
}
.newsInformationDetails-mainTop span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  margin-right: 15px;
  cursor: pointer;
}
.newsInformationDetails-mainTop span:first-child {
  color: #df3a3a;
}
.newsInformationDetails-main {
  display: flex;
  width: 1280px;
  margin: 0 auto;
}
.newsInformationDetails-mainLeft {
  border-top: 1px solid rgba(214, 219, 221, 0.4);
  width: 900px;
  margin-right: 53px;

  /* padding-top: 30px; */
}
.newsInformationDetails-mainRight {
  border-top: 1px solid rgba(214, 219, 221, 0.4);
  width: 367px;
}
.newsInformationDetails-mainLeftTop {
  border-bottom: 1px solid rgba(214, 219, 221, 0.4);
}
.newsInformationDetails-mainLeftTop .title {
  position: relative;
  margin: 30px 0 39px;
}
.newsInformationDetails-mainLeftTop .title img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: -14px;
}
.newsInformationDetails-mainLeftTop .title span {
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #2a2b33;
}
.newsInformationDetails-mainLeftTop .mainLeftTop-data {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.newsInformationDetails-mainLeftTop .zuozhe {
  margin-bottom: 52px;
}
.newsInformationDetails-mainLeftTop .zuozhe > span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  font-style: italic;
  color: rgba(69, 70, 71, 0.7);
  line-height: 19px;
}
.newsInformationDetails-mainLeftTop .mainLeftTop-data .yearBox {
  display: flex;
  flex-direction: column;
}
.newsInformationDetails-mainLeftTop .mainLeftTop-data .data {
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: 400;
  font-style: italic;
  color: #00000c;
  display: block;
  margin-right: 15px;
}
.newsInformationDetails-mainLeftTop .mainLeftTop-data .yearBox span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  font-style: italic;
  color: rgba(69, 70, 71, 0.7);
  line-height: 19px;
}
.newsInformationDetails-mainLeftTop
  .mainLeftTop-data
  .yearBox
  span:first-child {
  padding-left: 7px;
}
.newsInformationDetails-mainLeftText {
  margin-top: 30px;
  margin-bottom: 45px;
}
.newsInformationDetails-mainLeftText >>> p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 30px;
  text-indent: 30px;
}
.newsInformationDetails-mainLeftPic {
  margin-bottom: 90px;
}
.newsInformationDetails-mainLeftText >>> img {
  display: block;
  width: 900px !important;
  height: 455px;
}
.newsInformationDetails-mainLeftBottom .title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #df3a3a;
  display: block;
  margin-bottom: 32px;
  cursor: pointer;
}
.newsInformationDetails-mainLeftBottom > div {
  display: flex;
  flex-direction: column;
}
.newsInformationDetails-mainLeftBottom > div > span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  text-decoration: underline;
  color: #df3a3a;
  margin-bottom: 34px;
  cursor: pointer;
}
.newsInformationDetails-mainLeftBottom > div > span:last-child {
  margin-bottom: 94px;
}
.newsInformationDetails-mainRightTop {
  padding-top: 16px;
}
.newsInformationDetails-mainRightTop span {
  border-top: 3px solid #df3a3a;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  padding-top: 16px;
}
.newsInformationDetails-mainRightContent {
  margin-top: 40px;
}
.mainRightContent-box {
  display: flex;
  margin-bottom: 32px;
  cursor: pointer;
}
.mainRightContent-box .mainRightContent-boxLeft img {
  display: block;
  width: 114px;
  height: 74px;
  margin-right: 20px;
}
.mainRightContent-boxRight span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;

  /* 几行后显示省略号 */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 181px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #2a2b33;
  margin-bottom: 14px;
  /* line-height: 30px; */
}
.mainRightContent-boxRight p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(69, 70, 71, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/views/news/newsInformationDetails.vue